var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-screen paw-bg preloader"},[_c('div',{staticClass:"spinner"},[_c('img',{staticClass:"spinner-img",style:({transform: ("rotate(" + _vm.rotation + "deg)")}),attrs:{"src":require("@assets/img/loading-spinner.svg")}})]),_vm._v(" "),_c('span',{staticClass:"percent"},[_vm._v(_vm._s(Math.round(_vm.progress))+"%")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08dfceb5","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/abstract/AssetLoader.vue
// module id = null
// module chunks = 